import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'

Vue.use(firestorePlugin)

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBjhi0t1b3N65uHcTQYq_zH67jO0lDE4f8',
  authDomain: 'uruoifavoritelist-da5b3.firebaseapp.com',
  databaseURL: 'https://uruoifavoritelist-da5b3.firebaseio.com',
  projectId: 'uruoifavoritelist-da5b3',
  storageBucket: 'uruoifavoritelist-da5b3.appspot.com',
  messagingSenderId: '391077152077',
  appId: '1:391077152077:web:f5b972145c8981756a6304',
  measurementId: 'G-SLKZPEXM9N'
})

export const db = firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/plugins/firebase.js